import {
  tooltipOptions,
  GreyColors,
  teamColors,
} from '../../../shared/chart-options';
import { ScoreChartTooltip } from '../ScoreChartTooltip';
import { ScoreChartFFTooltip } from '../ScoreChartFFTooltip';

export function getScoreChartOptions(gameExplorerReport, factor) {
  const totalGameDuration =
    gameExplorerReport.gameDurationMinutes + gameExplorerReport.overtimeMinutes;

  const { homeSeries, visitorSeries } = getExplorerSeries(
    gameExplorerReport,
    factor,
  );

  return {
    grid: {
      left: 40,
      bottom: 20,
      right: 10,
      top: 20,
    },
    legend: {
      show: true,
      orient: 'vertical',
      top: 50,
      left: 50,
    },
    tooltip: {
      ...tooltipOptions,
      formatter: factor === 'points' ? ScoreChartTooltip : ScoreChartFFTooltip,
    },
    xAxis: getXAxis(totalGameDuration),
    yAxis: {
      type: 'value',
      min: 0,
      minInterval: 20,
      maxInterval: 20,
      axisLabel: GreyColors.axisLabel,
      axisLine: GreyColors.axisLine,
      axisTick: { lineStyle: GreyColors.lineStyle },
      splitLine: { lineStyle: GreyColors.splitLine },
    },
    series: [
      {
        name: gameExplorerReport.homeTeam.name,
        type: 'line',
        data: homeSeries,
        color: teamColors.homeColor,
        smooth: true,
      },
      {
        name: gameExplorerReport.visitorTeam.name,
        type: 'line',
        data: visitorSeries,
        color: teamColors.visitorColor,
        smooth: true,
      },
    ],
  };
}

function getXAxis(max) {
  const baseConf = {
    type: 'value',
    min: 0,
    max,
    minInterval: 0,
    maxInterval: 2,
    axisLabel: GreyColors.axisLabel,
    axisLine: GreyColors.axisLine,
    axisTick: { lineStyle: GreyColors.lineStyle },
    splitLine: { lineStyle: GreyColors.splitLine },
  };

  return [
    { ...baseConf, position: 'top' },
    { ...baseConf, position: 'bottom' },
  ];
}

function getExplorerSeries(gameExplorerReport, factor) {
  let mapper;

  if (!factor) mapper = getTeamPointsSeries;

  if (factor === 'efg') mapper = getTeamEfgSeries;
  else if (factor === 'orr') mapper = getTeamOrrSeries;
  else if (factor === 'ftr') mapper = getTeamFtrSeries;
  else if (factor === 'tov') mapper = getTeamTovSeries;
  else mapper = getTeamPointsSeries;

  const homeSeries = mapper(gameExplorerReport.homeShifts);
  const visitorSeries = mapper(gameExplorerReport.visitorShifts);

  return { homeSeries, visitorSeries };
}

function getTeamPointsSeries(shifts) {
  return shifts
    .map(shiftData => [shiftData.boxscore.pts, shiftData])
    .reduce(pointsAccumulator, [[0, 0]]);
}

function getTeamEfgSeries(shifts) {
  return shifts
    .map(shiftData => [shiftData.rolling.team.four_factors.efg, shiftData])
    .reduce(ffAccumulator, [[0, shifts[0].ffValue * 100]]);
}

function getTeamOrrSeries(shifts) {
  return shifts
    .map(shiftData => [shiftData.rolling.team.four_factors.orr, shiftData])
    .reduce(ffAccumulator, [[0, shifts[0].ffValue * 100]]);
}

function getTeamFtrSeries(shifts) {
  return shifts
    .map(shiftData => [shiftData.rolling.team.four_factors.ftr, shiftData])
    .reduce(ffAccumulator, [[0, shifts[0].ffValue * 100]]);
}

function getTeamTovSeries(shifts) {
  return shifts
    .map(shiftData => [shiftData.rolling.team.four_factors.tov, shiftData])
    .reduce(ffAccumulator, [[0, shifts[0].ffValue * 100]]);
}

function pointsAccumulator(series, [pts, shiftData]) {
  const prevPts = series[series.length - 1][1];
  const currentPoints = prevPts + pts;
  const currentMinutes = shiftData.endShiftTime;

  series.push([currentMinutes, currentPoints, shiftData]);

  return series;
}

function ffAccumulator(series, [ffValue, shiftData]) {
  const currentMinutes = shiftData.endShiftTime;

  series.push([currentMinutes, ffValue * 100, shiftData]);
  return series;
}
